import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import {
  fetchCampaignDetails,
  fetchCampaignRewards
} from '../../api/campaign.api';
import campaignDefault from '../../assets/campaign_default.png';
import AvailableRewards from './AvailableRewards';
import { CampaignDetailsSkeleton, RewardsSkeleton } from './details-skeleton';

const CampaignDetails = () => {
  const params = useParams();
  const { data: campaign, isLoading: isCampaignLoading } = useQuery({
    queryKey: ['campaignDetails', params.campaignId],
    queryFn: () => fetchCampaignDetails(params.campaignId || ''),
    enabled: !!params.id
  });
  const { data: rewardsRes, isLoading: isRewardsLoading } = useQuery({
    queryKey: ['campaignRewards', params.campaignId],
    queryFn: () => fetchCampaignRewards(params.campaignId || ''),
    enabled: !!params.id
  });

  console.log(campaign);

  // If campaign details are still loading, show campaign skeleton
  if (isCampaignLoading) {
    return <CampaignDetailsSkeleton />;
  }

  // If campaign failed to load, return null
  if (!campaign?.success) {
    return null;
  }

  return (
    <>
      {/* Campaign Details Section - Always rendered when campaign data is available */}
      <section className={'mx-auto w-full max-w-[calc(100%_-_2rem)]'}>
        <div className="flex flex-col gap-y-6">
          <div className="aspect-video max-h-80 w-full overflow-clip rounded-2xl bg-white p-2 md:p-4">
            <img
              src={campaign.data?.portal_image || campaignDefault}
              className={'object-fit aspect-video h-full rounded-md'}
              alt={campaign.data?.campaign_name || ''}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = campaignDefault;
              }}
            />
          </div>
          <div className="flex flex-col gap-y-2 px-4">
            <p className="text-base font-semibold">
              {campaign?.data?.campaign_name}
            </p>
          </div>
        </div>
        <div className="mt-4 flex flex-col gap-y-4 px-4">
          <p className=" ">{campaign?.data?.campaign_description}</p>
        </div>
      </section>

      {/* Rewards Section - Show skeleton while loading, content when loaded */}
      {isRewardsLoading ? (
        <RewardsSkeleton />
      ) : (
        rewardsRes?.success && (
          <div className="mx-auto mt-4 w-full max-w-[calc(100%_-_2rem)] px-4">
            <AvailableRewards
              availableRewards={rewardsRes?.data?.rewards || []}
              merchantName={rewardsRes?.data?.entity_name || ''}
            />
          </div>
        )
      )}
    </>
  );
};
export default CampaignDetails;
